import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7000Model } from '../kymw7000.model';
// import { TagInfo } from '../vo/tag-info.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 表紙特集商品選定情報保存(企画担当)サービス
 * @export SaveFeatureInfoByPlannerService
 * @class SaveFeatureInfoByPlannerService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SaveFeatureInfoByPlannerService extends PlessJsonResponderSub<null> {
  model: KYMW7000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SaveFeatureInfoByPlannerService
   */
  private getBody(): PlessRequest {
    const featureThema = {
      FeatureThema: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode,
          Memo: this.model.featureMemo,
        }
      }
    }
    const featureGoodsList = {
      FeatureGoodsList: {
        combination: this.model.SelectionList.map(item => ({
          parameter: {
            PCode: item.pCode,
            ItemCode: item.itemCode,
            StockNum: "",
            PricePattern: item.pricePattern,
            ThisTimeSupplyPrice: item.thisTimeSupplyPrice,
            ThisTimeCostPrice: item.thisTimeCostPrice,
            PlanNum: item.planNum,
            PlanSupplyBudget: item.planSupplyBudget,
            Remarks: item.remarks
          }
        }))
      }
    }
    const featureRequestBuyerList = {
      FeatureRequestBuyerList: {
        combination: this.model.SelectionRequestInfo.map(item => ({
          parameter: {
            BuyerRequestId: item.buyerRequestId,
            ClassCode: item.classCode,
            MiddleClassCode: item.middleClassCode,
            PCode: item.pCode,
            ThisTimeSupplyPrice: item.thisTimeSupplyPrice,
            PricePattern: item.pricePattern,
            PlanNum: item.planNum,
            PlanSupplyBudget: item.planSupplyBudget,
            Remarks: item.remarks
          }
        }))
      }
    }
    const updateObj = {
      update:{
        FeatureThema: featureThema.FeatureThema,
        FeatureGoodsList: featureGoodsList.FeatureGoodsList,
        FeatureRequestBuyerList: featureRequestBuyerList.FeatureRequestBuyerList
      }
    }

    return new PlessRequest(updateObj);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof SaveFeatureInfoByPlannerService
   */
  execute(model: KYMW7000Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('saveFeatureInfoByPlanner', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SaveFeatureInfoByPlannerService
   */
  success() {
    this.dialogService.openAlertGetMessage('I0508', ['一時保存']);
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    this.dialogService.openAlertGetMessage('E0574', ['一時保存']);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    this.dialogService.openAlertGetMessage('E0574', ['一時保存']);
  }
}
